/// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';

type Props = {
  url: ?string,
  icon?: string,
  label: ?string,
  isMedium?: boolean,
  isDark?: boolean,
  isDisabled?: boolean,
  isCompetition?: boolean,
  isPrimary?: boolean,
  isWhite?: boolean,
  isRed?: boolean,
  isFull?: boolean,
  isInline?: boolean,
  noIcon?: boolean,
  onClick?: Function,
  titleSEO?: string
};

class ButtonIcon extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    url: '#'
  };

  onClick = (e: MouseEvent) => {
    e.preventDefault();
    if (this.props.onClick) this.props.onClick(e);
  };

  render() {
    const {
      url,
      isMedium,
      isDark,
      isDisabled,
      isCompetition,
      isPrimary,
      isWhite,
      isRed,
      isFull,
      label,
      noIcon,
      isInline,
      titleSEO
    } = this.props;
    const classNamesButton = dynamicClassName('btn');
    const classNamesIcon = dynamicClassName('icon');

    this.props.icon && classNamesIcon.add(this.props.icon);
    isMedium && classNamesButton.add('btn--medium');
    isDark && classNamesButton.add('is-dark');
    isDisabled && classNamesButton.add('is-disabled');
    !isCompetition && !noIcon && classNamesButton.add('btn--icon');
    isCompetition && classNamesButton.add('btn--competition btn--competition');
    isPrimary && classNamesButton.add('btn--primary');
    isWhite && classNamesButton.add('btn--white');
    isRed && classNamesButton.add('btn--red');
    isFull && classNamesButton.add('btn--full');
    isInline && classNamesIcon.add('is-inline');

    /* @apsulis TBD si ça ouvre un lien, on peut le décrire, sinon, retirons le title (genre si c'est un button avec action JS) */
    if (url) {
      return (
        <Link to={url} title={titleSEO} className={classNamesButton.build()}>
          <i className={classNamesIcon.build()} />
          {label && <span>{label}</span>}
        </Link>
      );
    } else
      return (
        <a title={titleSEO} href={this.props.url} className={classNamesButton.build()} onClick={this.onClick}>
          <i className={classNamesIcon.build()} />
          {label && <span>{label}</span>}
        </a>
      );
  }
}

export default ButtonIcon;
